import ef from 'ef/ef';

var AssessmentService = {
  initialize: function(assessmentMap) {
    assessmentMap = (assessmentMap || {});
    this.mapping = assessmentMap;
    this.ContentProvider = require('services/content-provider');
  },

  getAssessment: function(courseSlug) {
    var slug;
    try {
      slug = ef.options.local ? courseSlug : this.getAssessmentActivity(courseSlug).slug;
    } catch(e) {
      slug = courseSlug;
    }
    return new ef.Models.Assessments.Assessment({slug: slug});
  },

  getUrl: function(courseSlug) {
    var activity = this.getAssessmentActivity(courseSlug);
    var redirectPath = window.location.pathname + '#' + ef.module.currentActivity.currentPage.path() + '?assessmentTaken=true';
    var url = '/assessments/attempts/:assessment_slug?redirect_url=:redirect_url';
    url = url.replace(':assessment_slug', activity.slug);
    url = url.replace(':redirect_url', encodeURIComponent(redirectPath));
    return url;
  },

  getBestScore: function(courseSlug) {
    return this.ContentProvider.AssessmentService.getBestScore(courseSlug, this.mapping);
  },

  getAssessmentStatus: function(courseSlug) {
    return this.ContentProvider.AssessmentService.getAssessmentStatus(courseSlug, this.mapping);
  },

  getAssessmentActivity: function(courseSlug) {
    return this.ContentProvider.AssessmentService.getAssessmentActivity(courseSlug, this.mapping);
  },

  userHasCompletedAssessment: function(courseSlug) {
    return this.ContentProvider.AssessmentService.userHasCompletedAssessment(courseSlug, this.mapping);
  },

  getActivityProgressForSlug: function(courseSlug) {
    return this.ContentProvider.AssessmentService.getActivityProgressForSlug(courseSlug, null, this.mapping);
  }
};

module.exports = AssessmentService;
